import Factory from '../factory';

const schema = Factory.schema('vacancies');

export default schema;
